import { useEffect } from 'react'

import { BadgeCountsSelector } from 'conversations/components/NewChatSidebar/ConversationListHeader'
import { inboxBadgeCounts } from 'conversations/modules/conversation/api'
import { getBadgeCounts } from 'conversations/modules/conversation/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { receiveBadgeCounts } from 'shared/store/actions/conversation'
import useSWR from 'swr'

export interface BadgeCounts {
  [key: number]: Record<number, number>
}

export default function useBadgeCounts(): BadgeCountsSelector {
  const dispatch = useDispatch()
  const { data: counts } = useSWR('/search/badgeMaps', inboxBadgeCounts, {
    dedupingInterval: 3000,
    revalidateOnFocus: false,
  })

  useEffect(() => {
    counts && dispatch(receiveBadgeCounts(counts))
  }, [dispatch, counts])

  const badgeCounts: BadgeCounts = useSelector(getBadgeCounts())
  const total = Object.values(badgeCounts).reduce(
    (acc, conversations) => acc + Object.keys(conversations).length,
    0
  )

  return { ...badgeCounts, total }
}
